import { useCallback, useState } from "react";

import {
  useLastModifiedFolderFilePerCurrentCustomerFolderCountLazyQuery,
  useLastModifiedFolderFilePerCurrentCustomerFolderExtractLazyQuery,
} from "src/core/gql/graphql";
import { FolderResult } from "src/core/hooks/folders-list/folder-risk-statistics/types";

export const useGetValidatedFolderFiles = () => {
  const [queryCountValidatedFolderFiles] =
    useLastModifiedFolderFilePerCurrentCustomerFolderCountLazyQuery();
  const [queryValidatedFolderFiles] =
    useLastModifiedFolderFilePerCurrentCustomerFolderExtractLazyQuery();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchAll = useCallback(async (): Promise<FolderResult[] | undefined> => {
    setIsLoading(true);
    setError(null);

    try {
      // On récupère le nombre de dossiers validés
      const countResult = await queryCountValidatedFolderFiles({
        fetchPolicy: "no-cache",
        nextFetchPolicy: "no-cache",
      });

      const total = countResult.data?.validated?.pageInfo?.totalCount ?? 0;
      if (total === 0) {
        return [];
      }

      // On fait autant de requêtes qu'il y a de dossiers validés
      const limit = 50;
      const pageCount = Math.ceil(total / limit);

      const offsets: number[] = Array.from({ length: pageCount }, (_, i) => i * limit);

      const pagesResults = await Promise.all(
        offsets.map(async (offset) => {
          return queryValidatedFolderFiles({
            variables: { offset },
            fetchPolicy: "no-cache",
            nextFetchPolicy: "no-cache",
          });
        })
      );

      const results = pagesResults
        .map((result) => result.data?.lastModifiedFolderFilePerCurrentCustomerFolder?.content ?? [])
        .flat();

      return results;
    } catch (error) {
      console.error("[useGetValidatedFolderFiles::fetchAll] Error: ", error);
      setError(error as Error);
    } finally {
      setIsLoading(false);
    }
  }, [queryCountValidatedFolderFiles, queryValidatedFolderFiles]);

  return { fetchAll, isLoading, error };
};
